// extracted by mini-css-extract-plugin
export default {"page":"utilization-report-page_page__Enl2K"};